// This module provides API call methods for Sephora Commerce Basket APIs:
// https://jira.sephora.com/wiki/display/ILLUMINATE/Basket+APIs

const getSamples = require('services/api/basket/getSamples');
const getBasketDetails = require('services/api/basket/getBasketDetails');
const addToCart = require('services/api/basket/addToCart');
const applyPromotion = require('services/api/basket/applyPromotion');
const updateBasket = require('services/api/basket/updateBasket');
const addSamplesToBasket = require('services/api/basket/addSamplesToBasket');
const addMsgPromotionToBasket = require('services/api/basket/addMsgPromotionToBasket');
const removePromotion = require('services/api/basket/removePromotion');
const removeSkuFromBasket = require('services/api/basket/removeSkuFromBasket');
const switchBasketItem = require('services/api/basket/switchBasketItem');

module.exports = {
    getSamples,
    getBasketDetails,
    addToCart,
    applyPromotion,
    updateBasket,
    addSamplesToBasket,
    addMsgPromotionToBasket,
    removePromotion,
    removeSkuFromBasket,
    switchBasketItem
};
